import { render } from "./AddUsefulInformation.vue?vue&type=template&id=2fd8e5f4&scoped=true"
import script from "./AddUsefulInformation.vue?vue&type=script&lang=js"
export * from "./AddUsefulInformation.vue?vue&type=script&lang=js"

import "./AddUsefulInformation.vue?vue&type=style&index=0&id=2fd8e5f4&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fd8e5f4"]])

export default __exports__